import { createSlice } from "@reduxjs/toolkit";
import { purchaseAction } from "../Actions/purchaseAction";

export const purchaseReducer = createSlice({
    name: "purchaseReducer",
    initialState: {
      isLoading: false,
      data: null,
      isError: false,
    },
    extraReducers: (builder) => {
      builder.addCase(purchaseAction.pending, (state, action) => {
        state.isLoading = true;
      });
      builder.addCase(purchaseAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
      builder.addCase(purchaseAction.rejected, (state, action) => {
        console.error("Error", action.payload);
        state.isError = true;
        state.isLoading = false;
      });
    },
  });